import {Navigate, Outlet} from "react-router-dom";
import {useAuth} from "react-oidc-context";
import {useAuthPermissions} from "../hooks/useAuthPermissions";
import SkeletonLoadingTS from "../components/SkeletonLoadingTS";

const ProtectedLayout = ({roles}) => {
  const auth = useAuth();
  const {verifyRole} = useAuthPermissions();

  if (auth.isLoading) {
    return <SkeletonLoadingTS />;
  }

  if (!auth.isAuthenticated) {
    return <Navigate to="/acceso" replace />;
  }

  if (!verifyRole(roles)) {
    return <Navigate to="/acceso?error=unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedLayout;
